import React from 'react';
import Icons from '../../assets';
import { HippoComponentProps } from '../index';

interface IconProps extends HippoComponentProps {
  name: string;
  size: 18 | 24;
}

const Icon: React.FC<IconProps> = ({ dataQA, className, name, size }) => {
  const iconName = `${name}_${size}dp`;
  const SvgIcon = Icons[iconName as keyof typeof Icons];

  if (!SvgIcon) {
    console.error(`Icon ${iconName} not found!`);
    return null;
  }

  return <SvgIcon data-qa={dataQA} className={className} />;
};

export default Icon;
